import React from 'react';
import { ListGroup, Accordion } from 'react-bootstrap';
import { identificationSidebar } from './data/identificationSidebar';
import './css/Sidebar.css';

const displayName = (parts) => (
  <>
    {parts && parts.map((part, i) => {
      if (part.script === 'deva') {
        return (
          <span key={i} className="name-deva">
            {part.token}
          </span>
        );
      }
      return (
        <span key={i} className="name-en">
          {part.token}
        </span>
      );
    })}
  </>
);

export function IdentificationRightSidebar({ onOpenPdf }) {
  const openPdf = (pdf) => {
    if (typeof onOpenPdf === 'function') {
      onOpenPdf(pdf);
    } else {
      window.open(`/docs/${pdf}`, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ListGroup>
      <ListGroup.Item style={{ backgroundColor: 'lightgray' }}>
        <p className="Title">Help</p>
      </ListGroup.Item>
      <div className="helpLinks">
        {identificationSidebar.map((row, i) => {
          if (row.tag === 'item') {
            const item = row.item;
            if (item.type === 'link') {
              return (
                <ListGroup.Item key={i}>
                  <a
                    href={item.target}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkLike"
                  >
                    {displayName(item.name)}
                  </a>
                </ListGroup.Item>
              );
            }
            if (item.type === 'file') {
              return (
                <ListGroup.Item
                  key={i}
                  className="linkLike"
                  onClick={() => openPdf(item.pdf)}
                >
                  {displayName(item.name)}
                </ListGroup.Item>
              );
            }
            if (item.type === 'glossary') {
              return (
                <ListGroup.Item key={i}>
                  {displayName(item.name)}
                </ListGroup.Item>
              );
            }
            return null;
          }
          if (row.tag === 'list') {
            return (
              <Accordion key={i} flush className="helpAccordion">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>{displayName(row.name)}</Accordion.Header>
                  <Accordion.Body className="p-0">
                    <ListGroup variant="flush">
                      {row.list.map((help, j) => {
                        const item = help.item;
                        return (
                          <ListGroup.Item
                            key={`${i}-${j}`}
                            className="linkLike"
                            action
                            onClick={() => item.type === 'file' && openPdf(item.pdf)}
                          >
                            {displayName(item.name)}
                          </ListGroup.Item>
                        );
                      })}
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            );
          }
          return null;
        })}
      </div>
    </ListGroup>
  );
}

export default IdentificationRightSidebar;
